import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
  NgZone,
  EventEmitter,
  Output
} from '@angular/core';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { ContentsPromotionalBanner, ContentsService } from '@vestiaire/api-sdk-angular';
import { Logger } from '@app/core/logging';
import { of as observableOf, Observable, interval } from 'rxjs';

@Component({
  selector: 'vc-promo-banner',
  templateUrl: './promo-banner.component.html',
  styleUrls: ['./promo-banner.component.scss']
})
export class PromoBannerComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  isHomePage: boolean;
  @ViewChild('banner', { read: ElementRef, static: false })
  banner: ElementRef;
  @ViewChild('bannerBaseline', { read: ElementRef, static: false })
  bannerBaseline: ElementRef;
  @ViewChild('bannerPromo', { read: ElementRef, static: false })
  bannerPromo: ElementRef;

  @Output() bannerLoaded: EventEmitter<boolean> = new EventEmitter();

  public promo$: Observable<ContentsPromotionalBanner>;
  public promoOn = false;
  public baselineOn = true;
  public baselineRelativePosition = false;
  public isAnimate = false;
  public isCmsShowed: boolean;
  private animation: any;
  private timer: any;
  private t: number;

  constructor(
    private contentsService: ContentsService,
    private platformService: PlatformService,
    private logger: Logger,
    private _ngZone: NgZone
  ) {}

  ngOnInit() {
    this.getBanner();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'isHomePage') {
        if (this.isHomePage) {
          this.animateBanner();
          this.setBannerHeight();
        } else {
          this.stopAnimation();
          this.resetBannerHeight();
        }
      }
    }
  }

  ngOnDestroy() {
    this.stopAnimation();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.isHomePage) {
      this.setBannerHeight();
    }
  }

  stopAnimation() {
    if (this.animation) {
      this.animation.unsubscribe();
    }
  }

  animateBanner() {
    if (!this.platformService.isBrowser) {
      return;
    }
    this.stopAnimation();
    this._ngZone.runOutsideAngular(() => {
      this.timer = interval(5000);
      this.animation = this.timer.subscribe(() => {
        this._ngZone.run(() => {
          this.rotateBanner();
        });
      });
    });
  }

  rotateBanner() {
    this.promoOn = !this.promoOn;
    this.baselineOn = !this.baselineOn;
  }

  getBanner() {
    if (!this.platformService.isBrowser) {
      return;
    }
    this.contentsService.listPromotionalBanners().subscribe(
      res => {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          const promo = res.data.pop();
          if (promo.content !== '' && promo.link) {
            this.bannerLoaded.emit(true);
            this.promo$ = observableOf(promo);
            this.isAnimate = true;
            if (this.isHomePage) {
              this.animateBanner();
              this.setBannerHeight();
            }
          } else {
            this.baselineRelativePosition = true;
          }
        }
      },
      err => {
        this.logger.error('Promotionnal banner not working', err);
      }
    );
  }

  setBannerHeight() {
    if (this.isHomePage) {
      clearTimeout(this.t);
      this.t = window.setTimeout(() => {
        this.resetBannerHeight();
        if (this.bannerBaseline && this.bannerPromo) {
          const bannerPromoHeight = this.bannerPromo.nativeElement.offsetHeight;
          const bannerBaselineHeight = this.bannerBaseline.nativeElement.offsetHeight;
          const bannerHeight = bannerPromoHeight > bannerBaselineHeight ? bannerPromoHeight : bannerBaselineHeight;
          this.banner.nativeElement.style.height = bannerHeight + 'px';
          this.bannerBaseline.nativeElement.style.height = bannerHeight + 'px';
          this.bannerPromo.nativeElement.style.height = bannerHeight + 'px';
        }
      }, 200);
    }
  }

  resetBannerHeight() {
    if (this.bannerPromo) {
      this.bannerPromo.nativeElement.style.height = 'auto';
    }
    if (this.bannerBaseline) {
      this.bannerBaseline.nativeElement.style.height = 'auto';
    }
    if (this.banner) {
      this.banner.nativeElement.style.height = 'auto';
    }
  }
}
